const PaletteButton = ({ label, isActive = false, onClick, boxColor = "#fff" }) => {
  return (
    <button
      className={`
            aspect-5/4 border-2 text-xs
            ${isActive ? "border-black" : "border-gray-200"}
          `}
      style={{ backgroundColor: boxColor }}
      onClick={onClick}
    >
      {label}
    </button>
  )
}

export default PaletteButton
